var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LessonEntityDetails__Component" },
    [
      _c("FieldInlineText", {
        attrs: { label: "כותרת" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.title,
          callback: function ($$v) {
            _vm.$set(_vm.model, "title", $$v)
          },
          expression: "model.title",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "תת כותרת" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.subtitle,
          callback: function ($$v) {
            _vm.$set(_vm.model, "subtitle", $$v)
          },
          expression: "model.subtitle",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "יוצר" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.author,
          callback: function ($$v) {
            _vm.$set(_vm.model, "author", $$v)
          },
          expression: "model.author",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "קישור" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.link,
          callback: function ($$v) {
            _vm.$set(_vm.model, "link", $$v)
          },
          expression: "model.link",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "תמונה" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.imageUrl,
          callback: function ($$v) {
            _vm.$set(_vm.model, "imageUrl", $$v)
          },
          expression: "model.imageUrl",
        },
      }),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-switch",
            {
              staticClass: "ltr",
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(_vm._s(_vm.model.status ? "פעיל" : "לא פעיל"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }